import {AriaAttributes, ButtonHTMLAttributes, DetailedHTMLProps, FC} from 'react'
import {KTSVG} from '../../_metronic/helpers'
import {Spinner} from 'react-bootstrap'

interface ActionIconProps
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    AriaAttributes {
  iconPath: string
  isLoading?: boolean
  hasWarning?: boolean
}

export const ActionIcon: FC<ActionIconProps> = ({isLoading, iconPath, className, ...props}) => {
  return (
    <button
      {...props}
      className={`btn btn-icon ${props.hasWarning ? 'btn-bg-warning' : 'btn-bg-light'} btn-active-color-primary btn-sm ${className}`}
    >
      {isLoading ? (
        <Spinner animation='border' size='sm' />
      ) : (
        <KTSVG className='svg-icon-3' path={iconPath} />
      )}
    </button>
  )
}

ActionIcon.defaultProps = {
  isLoading: false,
}
